import { useReducer } from 'react';

// 类似于class component的setState
const useSet = initState => {
    const [state, setState] = useReducer((state, newState) => {
        let action = newState;
        if (typeof newState === 'function') {
            action = action(state);
        }
        if (newState.action && newState.payload) {
            action = newState.payload;
            if (typeof action === 'function') {
                action = action(state);
            }
        }
        const result = { ...state, ...action };
        return result;
    }, initState);
    return [
        state,
        state => {
            setState(state);
        },
    ];
};

export default useSet;
